import { combineReducers } from "redux";
import alertsReducer, { AlertsState } from "./alerts/alertsReducer";
import configReducer, { ConfigState } from "./config/configReducer";
import authReducer, { AuthState } from "./auth/authReducer";
import exerciseSaleFiltersReducer, { ExerciseSaleFiltersState } from "./exerciseSaleFilters/exerciseSaleFiltersReducer";
import basketReducer, {BasketState} from "./basket/basketReducer";

export default combineReducers({
  alerts: alertsReducer,
  config: configReducer,
  auth: authReducer,
  exerciseSaleFilters: exerciseSaleFiltersReducer,
  basket: basketReducer,
});

export interface State {
  alerts: AlertsState;
  config: ConfigState;
  auth: AuthState;
  exerciseSaleFilters: ExerciseSaleFiltersState;
  basket: BasketState;
}
